import useTenantFeatures from '@/composables/useTenantFeatures';

export const isPartnershipResourcesVerificationEnabled = () => {
  const { isPartnershipResourcesVerificationEnabled } = useTenantFeatures();
  return isPartnershipResourcesVerificationEnabled.value;
};
